import React from 'react';

/** Lets a step's bar jump back to an earlier step; `null` draws a plain bar. */
export const WizardJumpContext = React.createContext<((step: number) => void) | null>(null);
